import { render, staticRenderFns } from "./Deconomy.vue?vue&type=template&id=1fac4bb3&"
import script from "./Deconomy.vue?vue&type=script&lang=js&"
export * from "./Deconomy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports